import { useEffect, useState } from 'react';
import { apiClient } from '../api/client';
import { PointWindgram } from '../api/types';

/**
 * Carica il windgram di un punto (app_windgram.php) per un giorno.
 *   loading   in corso
 *   ok        dati pronti
 *   na        non disponibile li' o quel giorno (404, nessun addebito)
 *   credit    credito esaurito per quel giorno (402)
 *   error     rete o server
 * Con lat/lon null non fa niente (resta 'loading'): serve a SpotOverlay prima che il sito
 * sia stato trovato.
 */
export type PointWindgramState =
  | { state: 'loading' }
  | { state: 'ok'; data: PointWindgram }
  | { state: 'na' | 'credit' | 'error'; error: string };

export const usePointWindgram = (lat: number | null, lon: number | null, day: number, reload = 0) => {
  const [res, setRes] = useState<PointWindgramState>({ state: 'loading' });

  useEffect(() => {
    if (lat === null || lon === null || isNaN(lat) || isNaN(lon)) return;
    let alive = true;          // cambiando giorno in fretta, vale solo l'ultima risposta
    setRes({ state: 'loading' });
    apiClient.getPointWindgram(lat, lon, day).then((r) => {
      if (!alive) return;
      if (r.ok) setRes({ state: 'ok', data: r.data });
      else if (r.status === 404) setRes({ state: 'na', error: r.error });
      else if (r.status === 402) setRes({ state: 'credit', error: r.error });
      else setRes({ state: 'error', error: r.error });
    });
    return () => { alive = false; };
  }, [lat, lon, day, reload]);

  return res;
};
